import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import axios from "axios";
import socket from "../../../context/socket";
import _ from "lodash";
import { fetchAdvisorData } from "../../../redux/advisor/advisorSlice";
import { fetchClientData } from "../../../redux/client/clientSlice";
import api from "../../../utils/api";

const Priorities = () => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [prioritiesData, setPrioritiesData] = useState();
  const [isError, setIsError] = useState("");
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const roomId = new URLSearchParams(useLocation().search).get("clientId");

  const { clientData } = useSelector((state) => state.client);

  const cardData = prioritiesData?.section || [];

  // Fetch belief cards
  useEffect(() => {
    api
      .get(`advisor/get_inbelief_section/first`)
      .then((response) => {
        setPrioritiesData(response.data);
        dispatch(fetchClientData(roomId));

      })
      .catch((error) => {
        console.error("Error fetching priorities data:", error);
      });

  }, [roomId]);

  // Fetch previously selected cards
  useEffect(() => {

    if (clientData?.rate_priorities_as_investor) {
      setSelectedCards(clientData.rate_priorities_as_investor);
    }
  }, [clientData]);


  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce((cards) => {
      socket.emit("message", { room: roomId, data: { selectedCards: cards } });
    }, 300),
    [roomId]
  );

  useEffect(() => {
    debouncedEmitMessage(selectedCards);
  }, [selectedCards, debouncedEmitMessage]);

  const handleCardClick = (_id) => {
    setSelectedCards((prev) => {
      const isSelected = prev.some((card) => card._id === _id);

      if (isSelected) {
        return prev
          .filter((card) => card._id !== _id)
          .map((card, index) => ({ ...card, priority: index + 1 }));
      } else {
        return [...prev, { _id, priority: prev.length + 1 }];
      }
    });
  };

  const handleNext = () => {
    const nextUrl = `/risk-reward?clientId=${roomId}`;
    const nextUrl2 = `/risk-reward`;

    const allSectionIds = cardData.map((section) => section._id);
    const selectedIds = selectedCards.map((card) => card._id);
  
    const allSelected = allSectionIds.every((id) => selectedIds.includes(id));
    if (!allSelected) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please Prioritize all Beliefs!",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
      return;
    }
  
    // Deep compare priorities and order
    const original = clientData?.rate_priorities_as_investor || [];
    const updated = selectedCards;
  
    const isSame = original.length === updated.length &&
      original.every((item, index) =>
        item._id === updated[index]._id && item.priority === updated[index].priority
      );
  
    const payload = {
      _id: roomId,
      ratePrioritiesAsInvestor: selectedCards,
    };
  
    api
      .post(`advisor/ratePrioritiesAsInvestor`, payload)
      .then(() => {
        console.log('Saved successfully',isSame);
        
        if (!isSame) {
          sendAggredStatus(); // Only call if changed
        }
  
        socket.emit("navigate", { room: roomId, url: nextUrl2 });
        navigate(nextUrl);
      })
      .catch((error) => {
        console.error("Error saving selected cards:", error);
      });
  };
  



  
  const sendAggredStatus = async () => {
    try {
      // Get current date and time
      const currentDateTime = new Date().toISOString();
  
       const res = await fetch("https://www.finedge.in/home/getRemoteHeaders");
      const data = await res.json()
      console.log('response',data?.ip);
  
      // Send data to backend
      const response = await api.post(
       "advisor/set_inbelief_agreed",
        {
          _id: roomId,
          inv_belief_agreed: 'no',
          inv_belief_agreed_date: currentDateTime,
          inv_belief_agreed_IP: data?.ip,
        }
      );
  
      // dispatch(fetchClientData(roomId));
      // console.log("sendAggredStatus", response);
    } catch (error) {
      console.log("Some Errors", error);
    }
  };

  const handleBack = () => {
    const prevUrl = `/investing-belief?clientId=${roomId}`;
    const prevUrl2 = `/investing-belief`;

    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  const getCardStyle = (_id) => ({
    backgroundColor: selectedCards.some((card) => card._id === _id)
      ? "#23674B"
      : "white",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    minHeight: "242px",
  });

  const getCardNumber = (_id) => {
    const card = selectedCards.find((c) => c._id === _id);
    console.log('fd', selectedCards, card, _id);
    return card?.priority || "";
  };

  return (
    <>
      <div className="container minht">
        <div className="row">
          <div className="col-md-12 col-lg-7">
            <h2 style={{ fontSize: "50px" }}>
              {prioritiesData?.title}
            </h2>
            <p className="fs-18">(Highest to Lowest)</p>
          </div>
          <div className="col-md-12 col-lg-5 d-flex justify-content-end ">
            {cardData.length > 0 && (
              <div
                className="card border-1 adjustwidth investingBeliefCard"
                onClick={() => handleCardClick(cardData[0]._id)}
              >
                <div className="card-body">
                  <h5 className="card-text reward23 pb-4  investingBeliefText">{cardData[0].title}</h5>
                  <img
                    src={cardData[0].icon}
                    className="card-img-position img-fluid d-block mx-auto"
                    alt={cardData[0].title}
                    style={{
                      height: "120px",
                      width: "120px",
                    }}
                  />

                  <div
                    className="border border-1 circle custom-circle"
                    style={{ position: "absolute", bottom: "25px" }}
                    >
                    <h3 className="text-center lh-53 darktext">
                    {getCardNumber(cardData[0]._id)}
                    </h3>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="row mt-3 d-flex justify-content-end ">
          <div className="col-md-12 col-lg-4"></div>
          <div className="col-md-12 col-lg-8">
            <div className="row">
              {cardData.slice(1).map((card) => (
                <div key={card._id} className="col-lg-6">
                  <div
                    className="card border-1 my-3 investingBeliefCard"
                    style={{ width: "auto", height: "274px" }}
                    onClick={() => handleCardClick(card._id)}
                  >
                    <div className="card-body">
                      <h5 className="card-text reward23 pb-4 investingBeliefText" style={{ width: "67%" }}>
                        {card.title}
                      </h5>
                      <div
                        className="border border-1 circle custom-circle"
                        style={{ position: "absolute", bottom: "25px" }}
                      >
                        <h3 className="text-center lh-53 darktext">
                          {getCardNumber(card._id)}
                        </h3>
                      </div>
                      <div className="d-flex justify-content-between align-items-center h-50">
                        <div></div>
                        <img
                          src={card.icon}
                          className="card-img-position img-fluid d-block mx-auto"
                          style={{
                            height: "150px",
                            width: "120px",
                          }}
                          alt={card.text}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col text-end mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <p className="text-danger fw-semibold">{isError}</p>
                <div>
                  <a onClick={handleBack}>
                    <img
                      className="arrow_next1"
                      src="assets/images/left-arrowpng.png"
                      alt=""
                    />
                  </a>
                  <a
                    href="javascript:void(0);"
                    className="ms-1"
                    onClick={handleNext}
                  >
                    <img
                      className="arrow_next"
                      src="assets/images/right-arrow.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Priorities;
